<button
  mat-icon-button
  type="button"
  (click)="onClick()"
  [disabled]="isRefreshing()"
  aria-label="Refresh"
  matTooltip="Refresh"
  class="refresh-button"
>
  <mat-icon [class.spinning]="isRefreshing()">refresh</mat-icon>
</button>
